import React from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";
import mq from "../../../helpers/media-queries";

import StockStatus from "./stock-status";
import Stars from "../../stars/Stars";

const El = styled.div`
    font-family: sans-serif;
    position: relative;
    position: relative;
    padding-right: ${rem(50)};
    margin-bottom: ${rem(30)};

    ${(props) =>
        props.hideMobile &&
        css`
            ${mq("sm", "max")} {
                display: none;
            }
        `}

    ${(props) =>
        props.showMobileOnly &&
        css`
            display: none;
            ${mq("sm", "max")} {
                margin-bottom: 0;
                margin-top: ${rem(25)};
                display: block;
                padding: ${rem(17)};
                padding-right: ${rem(17)};
                padding-top: 0;
            }
        `}

	h1 {
        font-family: serif;
        font-size: ${rem(29)};
        font-weight: 400;
        margin-bottom: ${rem(10)};
        max-width: 90%;
        ${(props) =>
            props.showMobileOnly &&
            css`
                ${mq("sm", "max")} {
                    max-width: 250px;
                }
            `}
    }
`;

const StarText = styled.div`
    font-weight: 400;
    font-size: ${rem(14)};
    color: #5a4a44;

    a {
        border-bottom: 1px solid #5a4a44;
        text-decoration: none;
        color: #5a4a44;
    }
`;

const DiscountBubble = styled.div`
    width: ${rem(65)};
    height: ${rem(65)};
    background: #9e3f3a;
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 999em;
    font-size: ${rem(13)};
    text-transform: uppercase;
    color: #fff;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    ${(props) =>
        props.showMobileOnly &&
        css`
            right: 17px;
        `}

    strong {
        display: block;
        font-size: ${rem(18)};
        font-weight: 800;
    }
`;

const Headline = ({ data, showMobileOnly, hideMobile }) => {
    return (
        <El showMobileOnly={showMobileOnly} hideMobile={hideMobile}>
            <h1>{data.title}</h1>
            <Stars>
                <StarText>
                    Rated Excellent -{" "}
                    <a href="https://royaltubs.co.uk/testimonials" target="_blank">
                        103 reviews
                    </a>
                </StarText>
            </Stars>

            <StockStatus uppercase={true} inStock={true} shippingInfo={"ships out in 1-3 days"} />

            <DiscountBubble showMobileOnly={showMobileOnly}>
                <span>
                    save
                    <br />
                    <strong>{data.discount}%</strong>
                </span>
            </DiscountBubble>
        </El>
    );
};

export default Headline;
